import { styled } from '@mui/system';
import { Paper, Button, Typography } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { getContrastColor } from '#component/theme';

export const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1)
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  '&:empty': {
    display: 'none'
  }
}));

export const AddButtonWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const StyledAddIcon = styled(AddCircleOutlineRoundedIcon, {
  shouldForwardProp: prop => prop !== 'isDisabled'
})(({ theme, isDisabled }) => ({
  color: isDisabled ? theme.palette.grey[600] : getContrastColor()
}));

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'showBorder'
})(({ theme, showBorder }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  ...(showBorder && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
